import { useRouter } from "next/router";
import { pdfDownloadHelper } from "../../common/files";
import * as GE from "./GroupEvent.styles";
import TypeTwo from "./types/typeTwo";
import TypeOne from "./types/typeOne";
import { useRef } from "react";
import { failAlert } from "../../common/alert";
import CountdownTimer from "../../common/CountdownTimer";
import { Spinner } from "react-bootstrap";
import Link from "next/link";
import { EmptyWrapper } from "../cart/cart-styles";

const GroupEventUI = (props) => {
  const router = useRouter();
  const {
    detailData,
    scroll,
    subChild,
    inputData,
    setInputData,
    handleInputData,
    confirmInsert,
    userInfo,
    cancelInsert,
    onClickHandleModal,
    typeOneUseForm,
    typeTwoUseForm,
    eventOpen,
  } = props;
  const stickyBodyRef = useRef(null);

  return (
    <>
      <GE.Container className="container">
        {eventOpen === "none" ? (
          <EmptyWrapper>
            <img
              src="https://image.caretbio.com/store/webhard/지칼렛_탄소_420x200.png"
              alt="empty-edu"
            />
            <h4 className="title">현재 신청가능한 교육이 없습니다.</h4>
            <div>
              <Link href="/esg-guide/letter">
                <a className="btn">ESG 뉴스레터 보러가기</a>
              </Link>
            </div>
          </EmptyWrapper>
        ) : (
          <GE.DetailWrapper>
            <GE.DetailSection className="single-content">
              <h3>{detailData?.title}</h3>
              <div
                dangerouslySetInnerHTML={{ __html: detailData?.content }}
                className="ck-content"
              />
            </GE.DetailSection>

            <GE.StickySection
              $scroll={scroll}
              onSubmit={
                (detailData?.type === "TYPE1" &&
                  typeOneUseForm.handleSubmit(confirmInsert, (errors) => {
                    if (errors) {
                      failAlert(Object.values(errors)[0].message);
                    }
                  })) ||
                (detailData?.type === "TYPE2" &&
                  typeTwoUseForm.handleSubmit(confirmInsert, (errors) => {
                    if (errors) {
                      failAlert(Object.values(errors)[0].message);
                    }
                  })) ||
                confirmInsert
              }
            >
              <GE.StickyHeader>
                <h4>{subChild} 신청</h4>
                {eventOpen === "proceeding" && (
                  <h6 className="d-flex align-items-center">
                    <span className="me-1">종료까지 </span>
                    <i className="fi-rs-alarm-clock" />{" "}
                    <CountdownTimer targetDate={new Date(detailData?.edate)} />
                    <span className="ms-1">남았습니다.</span>
                  </h6>
                )}
              </GE.StickyHeader>
              <GE.StickyBody ref={stickyBodyRef}>
                {userInfo?.Member?.ukey ? (
                  <>
                    {(eventOpen === "loading" && (
                      <div className="h-100 d-flex align-items-center justify-content-center">
                        <Spinner animation="border" role="status" />
                      </div>
                    )) ||
                      (eventOpen === "proceeding" && (
                        <>
                          {detailData?.type === "TYPE1" && (
                            <TypeOne
                              detailData={detailData}
                              inputData={inputData}
                              setInputData={setInputData}
                              handleInputData={handleInputData}
                              cancelInsert={cancelInsert}
                              onClickHandleModal={onClickHandleModal}
                              typeOneUseForm={typeOneUseForm}
                              stickyBodyRef={stickyBodyRef}
                            />
                          )}
                          {detailData?.type === "TYPE2" && (
                            <TypeTwo
                              detailData={detailData}
                              inputData={inputData}
                              setInputData={setInputData}
                              handleInputData={handleInputData}
                              cancelInsert={cancelInsert}
                              typeTwoUseForm={typeTwoUseForm}
                            />
                          )}
                        </>
                      )) ||
                      (eventOpen === "before" && (
                        <GE.TimerWrapper>
                          <h6>공동 구매 신청 오픈까지</h6>
                          <span className="d-flex">
                            <CountdownTimer
                              targetDate={new Date(detailData?.sdate)}
                            />{" "}
                            <span className="ms-1">남았습니다.</span>
                          </span>
                        </GE.TimerWrapper>
                      )) ||
                      (eventOpen === "after" && (
                        <GE.TimerWrapper>
                          <h6>마감된 {subChild}입니다.</h6>
                        </GE.TimerWrapper>
                      ))}
                  </>
                ) : (
                  <GE.GuestWrapper>
                    {(eventOpen === "loading" && (
                      <div className="h-100 d-flex align-items-center justify-content-center">
                        <Spinner animation="border" role="status" />
                      </div>
                    )) || (
                      <h6>
                        <a href="/login">로그인</a> 후 이용가능합니다.
                      </h6>
                    )}
                  </GE.GuestWrapper>
                )}
              </GE.StickyBody>
              <GE.StickyFooter>
                {router.pathname.includes("edu") ? (
                  <button
                    type="submit"
                    className="btn confirm"
                    disabled={detailData?.info?.id}
                  >
                    {detailData?.info?.id ? "신청완료" : "신청하기"}
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn confirm"
                    disabled={eventOpen !== "proceeding"}
                  >
                    {(eventOpen === "loading" && (
                      <div className="d-flex align-items-center justify-content-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="spinner-border-sm"
                        />
                      </div>
                    )) ||
                      (eventOpen === "proceeding" && "신청하기") ||
                      (eventOpen === "before" && (
                        <div className="d-flex align-items-center justify-content-center">
                          <CountdownTimer
                            targetDate={new Date(detailData?.sdate)}
                          />{" "}
                          <span className="ms-2">후 오픈</span>
                        </div>
                      )) ||
                      (eventOpen === "after" && "신청 마감")}
                  </button>
                )}
              </GE.StickyFooter>
            </GE.StickySection>
          </GE.DetailWrapper>
        )}
      </GE.Container>
    </>
  );
};
export default GroupEventUI;
